/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetAllQuestConfigsForUserResponseAllOf,
    GetAllQuestConfigsForUserResponseAllOfFromJSON,
    GetAllQuestConfigsForUserResponseAllOfFromJSONTyped,
    GetAllQuestConfigsForUserResponseAllOfToJSON,
    PaginatedResponse,
    PaginatedResponseFromJSON,
    PaginatedResponseFromJSONTyped,
    PaginatedResponseToJSON,
    PaginationInfo,
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    QuestConfig,
    QuestConfigFromJSON,
    QuestConfigFromJSONTyped,
    QuestConfigToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetAllQuestConfigsForUserResponse
 */
export interface GetAllQuestConfigsForUserResponse extends PaginatedResponse {
    /**
     * 
     * @type {Array<QuestConfig>}
     * @memberof GetAllQuestConfigsForUserResponse
     */
    questConfigs: Array<QuestConfig>;
}

export function GetAllQuestConfigsForUserResponseFromJSON(json: any): GetAllQuestConfigsForUserResponse {
    return GetAllQuestConfigsForUserResponseFromJSONTyped(json, false);
}

export function GetAllQuestConfigsForUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllQuestConfigsForUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...PaginatedResponseFromJSONTyped(json, ignoreDiscriminator),
        'questConfigs': ((json['questConfigs'] as Array<any>).map(QuestConfigFromJSON)),
    };
}

export function GetAllQuestConfigsForUserResponseToJSON(value?: GetAllQuestConfigsForUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...PaginatedResponseToJSON(value),
        'questConfigs': ((value.questConfigs as Array<any>).map(QuestConfigToJSON)),
    };
}


